import { render } from "./Friends.vue?vue&type=template&id=30f6a702&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"

import "./Friends.vue?vue&type=style&index=0&id=30f6a702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f6a702"]])

export default __exports__